/**
 * Return server response message based on status code
 */
export const responseHandler = (response: any) => {
  return response.message;
};
